import iconError from 'assets/image/icons/png/error.png'
import images from 'assets/image/wentWrong.png'
import { Link } from 'react-router-dom'
import { Button } from 'shared/ui'

import css from './ErrorPage.module.scss'

const DEFAULT_TITLE = 'Oooops.. Something went wrong.'

export const ErrorPage = () => {
	return (
		<main className={css.root}>
			<article className={css.card}>
				<img
					alt='error went wrong'
					className={css.decorate}
					height={274}
					src={images}
					width={352}
				/>

				<h1 className={css.title}>
					<img
						alt='error'
						className={css.warn}
						height={21}
						src={iconError}
						width={24}
					/>
					{DEFAULT_TITLE}
				</h1>

				<div className={css.buttons}>
					<Button
						as={Link}
						className={css.button}
						state={null}
						to='/campaigns'
						variant='bordered-dark'
					>
						Go home
					</Button>
					<Button
						as='a'
						className={css.button}
						href='mailto:support@snaily.io'
						rel='noopener noreferrer'
						target='_blank'
					>
						Support
					</Button>
				</div>
			</article>
		</main>
	)
}
